import React from 'react';
import { AdminCashRegisterMonitorDTO } from '../../../types/cash/adminCashMonitor';
import { formatCurrency } from '../../../utils/formatCurrency';

interface Props {
  register: AdminCashRegisterMonitorDTO;
  onClick: (register: AdminCashRegisterMonitorDTO) => void;
}

const STATUS_BADGE: Record<string, string> = {
  OPEN: 'bg-success/10 text-success',
  CLOSED: 'bg-meta-1/10 text-meta-1',
  NEVER_OPENED: 'bg-gray-200 text-gray-600 dark:bg-meta-4 dark:text-gray-300',
};

const STATUS_LABEL: Record<string, string> = {
  OPEN: 'Abierta',
  CLOSED: 'Cerrada',
  NEVER_OPENED: 'Sin uso',
};

const AdminCashRegisterMonitorCard: React.FC<Props> = ({ register, onClick }) => {
  const {
    registerName,
    registerCode,
    active,
    status,
    openedAt,
    closedAt,
    liveSummary,
    lastClosure,
  } = register;

  const summaryLine = (() => {
    if (status === 'OPEN') {
      return `Abierta ${openedAt ? new Date(openedAt).toLocaleString() : ''} · Efectivo esperado $${formatCurrency(
        liveSummary?.expectedAmount
      )}`;
    }
    if (status === 'CLOSED') {
      return `Último cierre ${closedAt ? new Date(closedAt).toLocaleString() : ''}${
        lastClosure ? ` · Diferencia $${formatCurrency(lastClosure.difference)}` : ''
      }`;
    }
    return 'Sin sesiones registradas';
  })();

  return (
    <button
      type="button"
      onClick={() => onClick(register)}
      className="w-full rounded-sm border border-stroke bg-white p-5 text-left shadow-default transition hover:border-primary hover:shadow-md dark:border-strokedark dark:bg-boxdark"
    >
      <div className="mb-2 flex items-start justify-between">
        <div>
          <h4 className="text-lg font-semibold text-black dark:text-white">
            {registerName}
          </h4>
          <p className="text-sm text-gray-500 dark:text-gray-400">{registerCode}</p>
        </div>

        <div className="flex flex-col items-end gap-1">
          <span
            className={`rounded-full px-3 py-1 text-xs font-medium ${STATUS_BADGE[status] ?? ''}`}
          >
            {STATUS_LABEL[status] ?? status}
          </span>
          {active === false && (
            <span className="text-xs text-meta-1">Terminal inactiva</span>
          )}
        </div>
      </div>

      <p className="text-sm text-gray-500 dark:text-gray-400">{summaryLine}</p>
    </button>
  );
};

export default AdminCashRegisterMonitorCard;
